import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getOwnerByIdRequest } from '../../api/Owner/order/getOwnerById/getOwnerById';
import { getListOwnerProductsRequest } from '../../api/Owner/getListOwnerProductsQuery';

import * as ActionTypes from './actionTypes';
import { LOAD_OWNER_INFO } from './actionTypes';

function* loadOwnerInfoWorker({ payload: ownerId }) {
  const meta = { ownerId, indexer: ownerId };

  yield executeSagaRequest(
    LOAD_OWNER_INFO,
    getOwnerByIdRequest({ ownerId }),
    meta,
  );
  yield put(LOAD_OWNER_INFO.end());
}
export function* loadOwnerInfoWatcher() {
  yield takeEvery(LOAD_OWNER_INFO.BASE, loadOwnerInfoWorker);
}

export function* loadOwnerProductsWorker({ payload }) {
  yield executeSagaRequest(
    ActionTypes.LOAD_OWNER_PRODUCTS,
    getListOwnerProductsRequest({ ownerId: payload }),
  );
  yield put(ActionTypes.LOAD_OWNER_PRODUCTS.end());
}
function* loadOwnerProductsWatcher() {
  yield takeEvery(
    ActionTypes.LOAD_OWNER_PRODUCTS.BASE,
    loadOwnerProductsWorker,
  );
}

export default function* ownerSaga() {
  try {
    yield all([
      loadOwnerProductsWatcher(),
      loadOwnerInfoWatcher(),
    ]);
  } catch (error) {
    logCritical(error);
  }
}
